// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1s-7";
export var adjustableWidthBorderHeld = "_1s-8";
export var arrow = "_1s-3";
export var arrowButton = "_1s-4";
export var headerCell = "_1s-0";
export var help = "_1s-2";
export var icon = "_1s-1";
export var iconWrapper = "_1s-6";
export var noBorder = "_1s-b";
export var nonAdjustableWidthBorder = "_1s-9";
export var nonAdjustableWidthBorderHeld = "_1s-a";
export var textButton = "_1s-5";